// ============================================================================
// Cross-section generation constants
// ============================================================================
export const MERGE_DISTANCE_THRESHOLD = 1.0; // Merge distance threshold (m)
export const CURVATURE_MAGNITUDE_THRESHOLD = 0.1; // Curvature magnitude threshold (1/m)
export const HORIZONTAL_THRESHOLD_X = 0.9; // Horizontal threshold for normalized direction X component
export const HORIZONTAL_THRESHOLD_Y = 0.2; // Horizontal threshold for normalized direction Y component
export const POSITION_EQUALITY_THRESHOLD = 0.001; // Position equality threshold (m)
export const DEGENERATE_SEGMENT_THRESHOLD = 1e-8; // Degenerate segment threshold (m)
export const MIN_CURVE_CONTEXT_POINTS = 3; // Minimum curve context points
// ============================================================================
// Label Constants for Cross-Section Generation
// ============================================================================
export const DEFAULT_STATION_INTERVAL = 20; // Default station interval (m)
// === Road-level labels ===
export const LABEL_BEGIN_ROAD_POINT = "BP"; // Begin point of entire road
export const LABEL_END_ROAD_POINT = "EP"; // End point of entire road
// === Segment-level labels ===
// NOTE: These labels are used internally during cross-section generation
// as temporary status indicators and are NOT included in the final output.
export const LABEL_BEGIN_SEGMENT = "BS"; // Begin point of segment
export const LABEL_END_SEGMENT = "ES"; // End point of segment
export const LABEL_MID_SEGMENT = "MS"; // Mid point of segment
// === Control point labels ===
export const LABEL_INTERMEDIATE_POINT_PREFIX = "IP"; // IntermediatePoint
export const LABEL_STATION_POINT_PREFIX = "SP"; // StationPoint
export const LABEL_CONTROL_POINT_PREFIX = "CP"; // ControlPoint
// === Curve labels ===
export const LABEL_BEGIN_CURVE_PREFIX = "BC"; // Curve beginning prefix
export const LABEL_END_CURVE_PREFIX = "EC"; // Curve end prefix
export const LABEL_FIRST_BEGIN_CURVE = "BC1"; // First curve beginning point
// === Interpolated point labels ===
export const LABEL_NO_PREFIX = "NO."; // Interpolated point prefix
// === Fallback labels ===
export const LABEL_UNKNOWN = "Unknown"; // Fallback label
// ============================================================================
// Label Format Functions
// ============================================================================
export function formatNoLabel(n) {
    return `${LABEL_NO_PREFIX}${n}`;
}
export function formatNoWithAdditionalDistanceLabel(n, additionalDistance) {
    return `${LABEL_NO_PREFIX}${n}+${additionalDistance.toFixed(4)}`;
}
export function formatSPLabel(n) {
    return `${LABEL_STATION_POINT_PREFIX}${n}`;
}
export function formatBCLabel(n) {
    return `${LABEL_BEGIN_CURVE_PREFIX}${n}`;
}
export function formatECLabel(n) {
    return `${LABEL_END_CURVE_PREFIX}${n}`;
}
export function formatCombinedCurveLabel(ecIndex, bcIndex) {
    return `${formatECLabel(ecIndex)}/${formatBCLabel(bcIndex)}`;
}
//# sourceMappingURL=constants.js.map